import styled from 'styled-components';

export const ProofOfDeliveryHeader = styled.div`
  padding: 24px 32px 20px;
  border-bottom: 8px solid #f1f1f4;
`;

export const ProofOfDeliveryTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 1.3;
  color: #232d3a;
`;

export const DeliveredAt = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  margin-top: 6px;

  strong {
    color: #232d3a;
    font-weight: 500;
  }
`;

export const PhotoArea = styled.div`
  position: relative;
`;

export const PhotoViewport = styled.div`
  height: 70vh;
  min-height: 320px;
  background: #fff;
  overflow: auto;
`;

// At zoom 1 the whole photo fits the viewport; larger zoom overflows and scrolls.
export const PhotoFrame = styled.div`
  display: flex;
  box-sizing: border-box;
  height: 100%;
  min-width: 100%;
  padding: 24px 32px 72px;

  img {
    display: block;
    margin: auto;
    width: auto;
    height: auto;
    max-width: ${({zoom}) => zoom * 100}%;
    max-height: ${({zoom}) => zoom * 100}%;
    border-radius: 4px;
    transition: max-width 0.2s ease, max-height 0.2s ease;
  }
`;

export const PhotoUnavailable = styled.div`
  padding: 40px 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #666;
  text-align: center;
`;

export const ZoomControls = styled.div`
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
`;

export const ZoomButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #232d3a;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: #f1f1f4;
  }

  &:disabled {
    color: #b8bcc6;
    cursor: default;
    background: transparent;
  }
`;
